import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GATEWAY_ROUTER_STRIPE_CREATE_OR_UPDATE_CUSTOMER_CONFIG = defineFcm(
	'gateway_router_stripe_create_or_update_customer_config',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
				supported_currencies: { type: 'array', shape: { type: 'string' } },
				safe_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
				supported_payment_method_brands: { type: 'array', shape: { type: 'string' } },
				supported_payment_method_countries: { type: 'array', shape: { type: 'string' } },
				block_listed_user_identifiers: { type: 'array', shape: { type: 'string' }, optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
